/* eslint-disable no-param-reassign */
import { createAction, createReducer } from "@reduxjs/toolkit"

const SET_DIRTY_MODE = createAction("SET_DIRTY_MODE")
const setLinearProgressAction = createAction("ui/setLinearProgress")

function toDirty() {
  return SET_DIRTY_MODE(true)
}

function reset() {
  return SET_DIRTY_MODE(false)
}

function toggleLinearProgress() {
  return (dispatch, getState) => {
    const state = getState()
    const { isLinearProgressEnabled } = state.ui
    dispatch(setLinearProgressAction(!isLinearProgressEnabled))
  }
}

function showLinearProgress() {
  return (dispatch) => {
    dispatch(setLinearProgressAction(true))
  }
}

function hideLinearProgress() {
  return (dispatch) => {
    dispatch(setLinearProgressAction(false))
  }
}

const initialState = {
  isDirty: false,
  isLinearProgressEnabled: false
}

const reducer = createReducer(initialState, {
  SET_DIRTY_MODE: (state, { payload }) => ({ ...state, isDirty: payload }),
  "ui/setLinearProgress": (state, { payload }) => {
    state.isLinearProgressEnabled = payload
  }
})

export default {
  actions: {
    toDirty,
    reset,
    toggleLinearProgress,
    showLinearProgress,
    hideLinearProgress
  },
  initialState,
  reducer
}
